import React from "react"
import { generatePath, Link, useNavigate } from "react-router-dom"
import { Button, Flex, Space, Typography } from "antd"

import { paths } from "@src/app/paths"

export const BanksDetailFormRedirect = () => {
  const navigate = useNavigate()

  return (
    <Space direction="vertical" size={0}>
      <Flex align="start" justify="space-between" style={{ width: "100%" }}>
        <Typography.Text strong style={{ fontSize: 16 }}>
          Bank details for fund withdrawals and balance top-ups in fiat
          currencies.
        </Typography.Text>
        <Button
          htmlType="button"
          id="GENERATED_ID_BANKSDETAILFORMREDIRECT_BUTTON_ADD_BANK_DETAILS_1"
          onClick={() =>
            navigate(generatePath(paths.bankDetailSlug, { id: "new" }))
          }
          size="large"
          type="primary"
        >
          Add Bank Details
        </Button>
      </Flex>
      <Typography.Text style={{ color: "#949597" }}>
        <Typography.Text style={{ color: "#FF4D4F" }}>
          Important!
        </Typography.Text>{" "}
        To be able to fiat withdrawal, you need to pass{" "}
        <Link
          id="GENERATED_ID_BANKSDETAILFORMREDIRECT_LINK_KYB_PROCEDURE_1"
          to={paths.kyb}
        >
          KYB procedure
        </Link>{" "}
        at least Lv.2
      </Typography.Text>
    </Space>
  )
}
